// src/features/social/PerfilDeepLinkBridge.jsx
//
// Ponte deep link → perfil social. O link de compartilhar perfil
// (https://www.lesvita.com/app/perfil?id=<uid>) termina numa navegação para
// /plataforma/pessoal?...&perfilUid=<uid> — este componente (montado DENTRO do
// Router, junto do DeepLinkListener) lê o parâmetro, abre o offcanvas global
// de perfil (UserProfileContext) e LIMPA o parâmetro da URL, para voltar/
// recarregar não reabrir o perfil sem querer.
//
// Cobre os quatro caminhos com um código só: app já aberto (appUrlOpen), cold
// start (getLaunchUrl), navegador (rota /app/perfil) e pós-login (destino
// pendente restaurado) — todos desembocam na mesma query.

import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserProfile } from "../../contexts/UserProfileContext.jsx";

export default function PerfilDeepLinkBridge() {
  const location = useLocation();
  const navigate = useNavigate();
  const { openProfile } = useUserProfile();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const uid = params.get("perfilUid");
    if (!uid) return;
    openProfile(uid);
    params.delete("perfilUid");
    const query = params.toString();
    navigate(`${location.pathname}${query ? `?${query}` : ""}`, { replace: true });
  }, [location.search, location.pathname, navigate, openProfile]);

  return null;
}
